export default function BenefitCard({ icon, title, description }) {
  return (
    <div className="group relative bg-white/70 backdrop-blur-lg border border-gray-200 rounded-2xl p-6 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 hover:border-[#B8893A]/40">

      {/* Glow Effect */}
      <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition duration-300 bg-gradient-to-br from-[#B8893A]/10 to-transparent"></div>

      {/* Icon */}
      <div className="relative w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-[#B8893A]/20 to-[#B8893A]/5 text-[#B8893A] mb-5 transition-transform duration-300 group-hover:scale-110">
        {icon}
      </div>

      {/* Content */}
      <h3 className="relative text-base font-semibold text-[#0A0A0A] mb-2 group-hover:text-[#B8893A] transition-colors">
        {title}
      </h3>

      <p className="relative text-sm text-gray-500 leading-relaxed">
        {description}
      </p>

      {/* Bottom Accent Line */}
      <div className="absolute bottom-0 left-6 right-6 h-[2px] bg-gradient-to-r from-transparent via-[#B8893A]/40 to-transparent opacity-0 group-hover:opacity-100 transition duration-300"></div>
    </div>
  );
}
